module.exports = __webpack_public_path__ + "static/media/11a-01-HOME_ST-2011-200x300cm-oleo-sobre-papel.5194422a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/11/11a-01-HOME_ST-2011-200x300cm-oleo-sobre-papel.jpg
// module id = 121
// module chunks = 0